// extracted by mini-css-extract-plugin
export default {"selector":"ScenarioSelector_selector__3VXQb"};